import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatFormFieldModule, MatFormField } from '@angular/material/form-field';
import { MatInputModule, MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';

import { AddCameraWizardComponent } from './add-camera-wizard.component';
import { WizardCoreSelectionComponent } from './components/wizard-core-selection/wizard-core-selection.component';
import { WizardDetectionMethodComponent } from './components/wizard-detection-method/wizard-detection-method.component';
import { WizardScanSelectionComponent } from './components/wizard-scan-selection/wizard-scan-selection.component';
import { WizardAuthenticationComponent } from './components/wizard-authentication/wizard-authentication.component';
import { WizardConfigurationComponent } from './components/wizard-configuration/wizard-configuration.component';
import { ConfigureCamerasDialogComponent } from './dialogs/configure-cameras-dialog/configure-cameras-dialog.component';
import { CameraStorageSettingsTabComponentV2 } from '../../pages/location-v2/pages/device/pages/device-list/components/camera-storage-settings-tab/camera-storage-settings-tab-v2.component';

import { EdgePickerInlineComponent } from '../edge-picker-inline/edge-picker-inline.component';
import { CameraModule } from '../../pages/camera/camera.module';
import { UiPreloaderComponent } from '../../shared/ui-kit/ui-preloader/ui-preloader.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthSrcDirective } from '../../shared/directives/auth-src.directive';
import { UiButtonComponent, UiToggleComponent } from '@ui';
import { DirectivesModule } from '../../shared/directives/directives.module';

@NgModule({
  declarations: [
    AddCameraWizardComponent,
    WizardCoreSelectionComponent,
    WizardDetectionMethodComponent,
    WizardScanSelectionComponent,
    WizardAuthenticationComponent,
    WizardConfigurationComponent,
    ConfigureCamerasDialogComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatDialogModule, MatProgressBarModule, MatProgressSpinnerModule, MatTableModule, MatCheckboxModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatTooltipModule, MatMenuModule, MatSelect, MatFormField, MatInput, MatOption, EdgePickerInlineComponent, UiButtonComponent, DirectivesModule, CameraModule, UiPreloaderComponent, MatRadioModule, CameraStorageSettingsTabComponentV2, UiToggleComponent, TranslatePipe, AuthSrcDirective],
  exports: [AddCameraWizardComponent],
})
export class AddCameraWizardModule { }
